<template>
  <div class="home">
    <GigGuide/>
  </div>
</template>

<script>
// @ is an alias to /src
import GigGuide from '@/components/GigGuide.vue'

export default {
  name: 'home',
  components: {
    GigGuide
  }
}
</script>
